<template>
  <div class="quantity-selector">
    <div class="control minus" @click="$emit('clickMinus')"></div>
    <div class="amount">{{ amount }}</div>
    <div class="control plus" @click="$emit('clickPlus')"></div>
  </div>
</template>

<script>
  export default {
    name: 'QuantitySelector',
    props: {
      amount: {
        type: Number,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/QuantitySelector.vue